module.exports = __webpack_public_path__ + "static/media/stepper-compile-active.6b1853e7.svg";